module.exports = __webpack_public_path__ + "img/bobblehead_albert_einstein.7f1519ef.jpg";